import { render, staticRenderFns } from "./ChipTabs.vue?vue&type=template&id=45cd12f4&scoped=true"
import script from "./ChipTabs.vue?vue&type=script&lang=js"
export * from "./ChipTabs.vue?vue&type=script&lang=js"
import style0 from "./ChipTabs.vue?vue&type=style&index=0&id=45cd12f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cd12f4",
  null
  
)

export default component.exports